module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-bodymatter element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-004"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-004-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-004-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("D")]), _vm._v("eclan watched as Izzy shuddered,")]), _vm._v(" her head over the toilet as she threw up again. He could see her grief was physical. Raw, uncompromising and resolute. She had been sick from the morning after the wedding. He couldn’t bring himself to call it the day of the murder. He wanted to refer to the day as Lara’s wedding rather than Esme’s death. He was stupid and pig headed. It didn’t change a thing – no matter what he called the bloody "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("day")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He could imagine no end to this. How could they find their way back from the horror of losing a child in such a brutal way? There would be no finding a ‘new normality’ that God-awful phrase that had been bandied about after his legs had been blown off. He reached from the chair to hand Izzy a towel to wipe her face. She had been sick during her pregnancies. Hyper emesis the doctors had said – grave sickness was the translation from Latin. Now her body appeared as if it was being held hostage by the same sickness only now it was bearing witness to death instead of new "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("life")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She ran the cold water and splashed her face. ‘Thanks,’ she said. ‘I can’t seem to keep anything "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("down")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v(" ‘It’s shock,’ he said, stating the obvious. ‘Your body is reacting to the stress and "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("trauma")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Declan manoeuvred himself out of the downstairs bathroom, the door had been made wider to accommodate his chair. Lots of little changes and alterations to help make his disability more palatable. He could think of nothing to help lessen the grief he felt now. Nothing beyond catching the bastard and seeing him brought to "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("justice")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Do you know, I can’t for the life of me remember who told me about Esme,’ Izzy said following Declan into the living room. She sat looking out over their "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("garden")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘My brain has blanked out the messenger completely. I keep asking how could this happen to Esme, to us?’ she bent over clutching at herself as if there was a physical pain surging through her "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("body")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He was at a loss as to know how to help her. He instinctively wanted to hold her and offer some sort of comfort but they were past that kind of "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("affection")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Turning her head towards him she said, ‘Isn’t it ridiculous that only a week ago we were up to our eyes in all the wedding planning. Chair covers, buttonhole flowers, bloody twinkling fairy lights.’ She grasped at her head as if she could dislodge the horror. She made a sound, like a strangled "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("sob")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It’s as if I’m drowning. Declan, I can’t take this,’ her tone was almost pleading, as if she needed Declan to fix it all, to make this nightmare "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("dissipate")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I know Izzy. Life has a way of doing that – everything turns on an axis and we go from one extreme to the other.’  He had seen it before. The grandmother raped and murdered in her bed. Someone’s son shot in the back of the head for dealing drugs in the wrong area. A Filipino girl, traveling miles from home, to start a new life only to find the nannying agency is really a sex ring. Bearing witness to someone else’s nightmare was different from living in your own. The bomb should have been his lot. He often thought over the years, that surely nothing worse could ever happen. Though sometimes in the dead of the night fear, that it might, nagged at "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("him")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘To think of all the time taken up by the wedding preparations. I was cross at Lara for insisting on burlap wrapped jam jars with tea lights instead of the crystal candleholders. All the while Esme had kept to the background, consumed with her life at school and going out with her "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("friends")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She put her face in her hands, ‘Jesus, I can’t even remember when I last spent time with Esme, one on one. What with work and the wedding, life ran away from me. How had any of it seemed important?’ She was walking around the room now, without purpose. Her grief scared Declan. He needed her to hold it "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("together")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She turned abruptly, ‘You don’t think a guest did it, do you? It can’t be someone we "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("know")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘God, I hope not.’ They both fell silent, contemplating the unthinkable. He couldn’t bring himself to tell Izzy that in most murder cases the killer knows the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("victim")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘They’ll catch whoever did this, won’t they?’ again she was pleading with "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("him")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’ll make fucking sure they do.’ His clenched fists were lodged down the sides of his chair. Every muscle in his body was tight, as if ready to spring in to "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("action")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Did they tell you what she was like? How she was when they found her?’ her voice was hoarse, worn out from "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("crying")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Only that she hadn’t been dead long.’ Declan had no wish to tell Izzy that in all likelihood their daughter’s body had been flaccid, not yet rigid from death. That her features may have been frozen in place, her mouth open in a silent scream for help. That her pink bridesmaid dress had been bloodied and dirty, possibly tore and that a huddle of forensics people in white bodysuits would be scraping at her fingernails, collecting samples of secretions, while the photographers would be documenting the scene, click by click. Like all young girls, she was constantly photographed in life, by her friends and by herself, searching for the perfect selfie or profile shot to post on Facebook and Instagram. Now in death she would also be "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("documented")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He knew that where she had been found was little more than a ditch running alongside the river Lagan that the hotel backed on to. A scenic spot by day, which would now take on all the trappings of the macabre, for kids to visit and taunt each other with tales of the girl, their daughter, found murdered in the undergrowth at her sister’s "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("wedding")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01b9192d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-004.vue
// module id = 84
// module chunks = 0